import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { UtenteForm } from '../../../form/profili-utente/utente-form';
import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';
import { UtenteProfiloTemplate } from '../../../models/profili-utente/utente-profilo-template';
import { FormValidationService } from '../../../services/form-validation.service';

declare var closeModal: any;

@Component({
    selector: 'div [utente-add-form]',
  templateUrl: '../../../form/profili-utente/utente-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class UtenteAddComponent extends UtenteForm implements OnInit {
  private utente: UtenteProfilo;
  private urlInsert: string;
  @Input() display: boolean;

  @Output()
  onReturnUtente: EventEmitter<UtenteProfiloTemplate> = new EventEmitter<UtenteProfiloTemplate>();

  constructor( @Inject(OperationsService) operationService,
               @Inject(FormBuilder) campiForm,
               @Inject(HelpersService) helpers: HelpersService,
               @Inject(FormValidationService) formValidationService: FormValidationService) {
    super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Aggiungi utente');
    this.isInserimento(true);
  }


  getUtente() {
    return this.utente;
  }

  getRequest(request: UtenteProfiloTemplate) {
    this.onReturnUtente.emit(request);
  }

  datiUtenteProfilo(response) {
    if (response.returnCode === 'OK') {
//      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(urlInsert: string, urlGetTemplates: string, urlGetTemplate: string, utente: UtenteProfilo) {
    this.utente = utente;
    this.urlGetTemplates = urlGetTemplates;
    this.urlGetTemplate = urlGetTemplate;
    this.populateSelect();
    this.createForm();
    this.urlInsert = urlInsert;
  }
}
